import { useKeyPress } from './useKeyPress';

export const useZKeyPress = ({ handler }: { handler: () => void }) => {
  useKeyPress({ z: handler });
};
